<template>
  <div>
    <el-card class="card-box" v-if="hasBindData.isExistPaypalSet">
      <el-button
        type="primary"
        size="medium"
        @click="onBindSetting"
        class="add-account-btn"
        v-auth="'paypal::setting::handle-paypal'"
      >
        {{ $t('paypal::setting::绑定账户') }}
      </el-button>

      <el-form inline>
        <el-form-item :label="$t('paypal::setting::PayPal账户')">
          <el-input
            v-model="params.accountName"
            :placeholder="$t('paypal::setting::Paypal账户_placeholder')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('paypal::setting::店铺')">
          <el-select v-model="params.shopId" clearable :placeholder="$t('paypal::setting::店铺_placeholder')">
            <el-option
              v-for="(item, index) in shopList"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('paypal::setting::状态')">
          <el-select v-model="params.status" :placeholder="$t('paypal::setting::状态_placeholder')" clearable>
            <el-option
              v-for="(item, index) in statusConfig"
              :key="index"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">{{ $t('system::common::btn::search') }}</el-button>
          <el-button @click="reset">{{ $t('system::common::btn::reset') }}</el-button>
        </el-form-item>
      </el-form>

      <z-table
        ref="table"
        v-loading="loading"
        :data="tableData"
        :max-height="500"
        :pagination.sync="pagination"
        :columns="compColumns"
        @page-change="getPaypalList"
      >
        <template #accountName="{ row }">
          <div class="account-tip">
            <span>{{ row.accountName }}</span>
            <el-tooltip placement="top" v-show="row.bindStatus != 1">
              <div slot="content">
                <div v-if="row.bindStatus == 0 || row.bindStatus == 3">
                  <span>{{ $t('paypal::setting::reAuth') }}</span>
                  <el-button type="text" style="padding: 0; font-size: 12px" @click="reAuth(row, 1)">
                    {{ $t('paypal::setting::reAuth_btn') }}
                  </el-button>
                </div>
                <div v-if="row.bindStatus == 2 || row.bindStatus == 3">
                  <span>{{ $t('paypal::setting::reEdit') }}</span>
                  <el-button type="text" style="padding: 0; font-size: 12px" @click="reAuth(row, 2)">
                    {{ $t('paypal::setting::reEdit_btn') }}
                  </el-button>
                </div>
              </div>
              <i class="iconfont icona-02tanhao" v-auth="'paypal::setting::handle-paypal'"></i>
            </el-tooltip>
          </div>
        </template>
        <template #shopList="{ row }">
          <span>{{ row.shopList && row.shopList.map(el => el.shopName).join('、') }}</span>
        </template>
        <template #status="{ row }">
          <span>
            {{ statusConfig[row.status] ? statusConfig[row.status].name : '' }}
          </span>
        </template>
        <template #hasManager="{ row }">
          <span>
            {{ row.hasManager ? '是' : '否' }}
          </span>
        </template>
        <template #operate="{ row }">
          <el-button @click="edit(row)" type="text">
            {{ $t('system::function::edit') }}
          </el-button>
          <el-button @click="isDelete(row)" type="text" style="color: red">
            {{ $t('system::function::delete') }}
          </el-button>
        </template>
      </z-table>
    </el-card>
    <div v-else>
      <emptyCard
        :data="{
          title: $t('paypal::setting::empty_title'),
          img: require('@/assets/images/emptyDefault/paypal.png'),
          desc: $t('paypal::setting::empty_tip'),
          buttons: [
            { click: onBindSetting, text: $t('paypal::setting::绑定账户'), auth: 'paypal::setting::handle-paypal' },
          ],
        }"
      ></emptyCard>
    </div>
    <handleDialog v-model="dialogVisible" :drawRow="drawRow" @save="onSave"></handleDialog>
  </div>
</template>

<script>
import handleDialog from './components/handleDialog.vue'
import { deletePaypalAccount, getPaypalList, authPaypalAccount, resetPaypalAccount } from '@/server/paypal'
export default {
  components: { handleDialog },
  data() {
    return {
      loading: false,
      params: {
        accountName: '',
        shopId: '',
        status: '',
      },
      drawRow: {
        type: 'add',
        data: {},
      },
      columns: [
        {
          label: this.$t('paypal::setting::PayPal账户'),
          prop: 'accountName',
          minWidth: 150,
        },
        {
          prop: 'shopList',
          label: this.$t('paypal::setting::店铺'),
          minWidth: 150,
        },
        {
          prop: 'company',
          label: this.$t('paypal::setting::企业名称'),
          minWidth: 120,
        },
        {
          prop: 'status',
          label: this.$t('paypal::setting::状态'),
          minWidth: 150,
        },
        {
          prop: 'hasManager',
          label: this.$t('paypal::setting::有客户经理'),
          minWidth: 100,
        },
        {
          prop: 'operate',
          label: this.$t('paypal::setting::操作'),
          width: '180',
          fixed: 'right',
        },
      ],
      tableData: [],
      dialogVisible: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      statusConfig: {
        1: { name: this.$t('paypal::setting::正常'), value: 1 },
        // 2: { name: this.$t('paypal::setting::不可提现'), value: 2 },
        // 3: { name: this.$t('paypal::setting::冻结'), value: 3 },
        4: { name: this.$t('paypal::setting::不可收款'), value: 4 },
      },
    }
  },
  async mounted() {
    if (this.$route.query.merchantIdInPayPal) {
      this.authPaypalAccount()
    }
    // !this.$auth('paypal::setting::handle-paypal') && this.columns.pop()
    this.$store.dispatch('getShopList')
    this.getPaypalList()
  },
  computed: {
    shopList() {
      return this.$store.state.products.shopList
    },
    compColumns() {
      //没有操作权限则不显示操作列
      if (!this.$auth('paypal::setting::handle-paypal')) {
        return this.columns.slice(0, -1)
      }
      return this.columns
    },
  },
  methods: {
    onBindSetting() {
      this.dialogVisible = true
      this.drawRow = {
        type: 'add',
        data: {},
      }
    },
    async getPaypalList() {
      this.loading = true
      let params = {
        ...this.params,
        ...this.pagination,
      }
      delete params.total
      let { data } = await getPaypalList({ ...params })
      if (data.code === this.$code) {
        this.tableData = data.data.items || []
        this.pagination.total = data.data.totalCount
      }
      this.loading = false
    },
    search() {
      this.pagination.pageNum = 1
      this.getPaypalList()
    },
    reset() {
      this.pagination.pageNum = 1
      this.params = {
        accountName: '',
        shopId: '',
        status: '',
      }
      this.getPaypalList()
    },
    edit(row) {
      this.dialogVisible = true
      this.drawRow = {
        type: 'edit',
        data: { ...row },
        error: row.bindStatus == 2 || row.bindStatus == 3,
      }
    },
    reAuth(row, type) {
      // 1 合作伙伴权限被删除，无法获取账户状态  2 app被移除，无法获取账户余额/企业名称
      switch (type) {
        case 1:
          this.getReAuthLink(row.id)
          break
        case 2:
          this.edit(row)
          break
      }
    },
    isDelete(row) {
      this.$confirm(
        this.$t('paypal::setting::delete_title') + '<br/>' + this.$t('paypal::setting::delete_tip'),
        this.$t('system::common::dialog::删除'),
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('system::common::btn::confirm'),
          cancelButtonText: this.$t('system::common::btn::cancel'),
        }
      ).then(() => {
        this.deletePaypalAccount(row)
      })
    },
    async deletePaypalAccount(row) {
      let { data } = await deletePaypalAccount(row.id)
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::delete_success'))
        this.getPaypalList()
      }
    },
    async onSave() {
      this.getPaypalList()
      if (!this.hasBindData.isExistLogistics) await this.$store.dispatch('getBindData')
    },
    async authPaypalAccount() {
      const {
        merchantId,
        merchantIdInPayPal,
        permissionsGranted,
        accountStatus,
        consentStatus,
        productIntentId,
        isEmailConfirmed,
        returnMessage,
        riskStatus,
      } = this.$route.query
      const { data } = await authPaypalAccount({
        merchantId,
        merchantIdInPaypal: merchantIdInPayPal,
        permissionsGranted,
        accountStatus,
        consentStatus,
        productIntentId,
        isEmailConfirmed,
        returnMessage,
        riskStatus,
      })
      if (data.code === this.$code) {
        this.getPaypalList()
      }
    },
    async getReAuthLink(id) {
      const { data } = await resetPaypalAccount(id)
      if (data.code === this.$code) {
        window.location.href = data.data
      }
    },
  },
  watch: {
    tableData(val, oldVal) {
      if (val.length === 0 && val.length !== oldVal.length) {
        this.$store.dispatch('getBindData')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.add-account-btn {
  position: absolute;
  top: 10px;
  right: 16px;
}
.title {
  font-size: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  div:first-child {
    font-weight: 600;
  }
  div + div {
    margin-top: 10px;
  }
  .tip {
    font-size: 14px;
    color: #9da1c3;
  }
}
.icondelete {
  color: #9da1c3;
}
.icon-a-01wenhao {
  font-size: 14px;
  margin-left: 10px;
  margin-right: 5px;
}
.dian {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
.account-tip {
  display: flex;
  align-items: center;
  .icona-02tanhao {
    margin-left: 8px;
    font-size: 18px;
    color: #ff5928;
  }
}
</style>
